import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { appendOwnersCtaReveal } from "./owners-cta-gsap.js";

gsap.registerPlugin(ScrollTrigger);

const reducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
).matches;

if (!reducedMotion) {
  document.querySelectorAll(".owners-cta").forEach((section) => {
    gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top 85%",
          toggleActions: "play none none none",
        },
        defaults: { ease: "power2.out" },
      });

      appendOwnersCtaReveal(tl, section, 0);
    }, section);
  });
}
